module.exports = __webpack_public_path__ + "64ffbd7246894ba76d881e2c4bd85667.png";